import { helper } from '@ember/component/helper';

import { formatDate } from 'rise-ui/utils/date.js';

export default helper(function dateTimeHelper([ date ]) {
  return date instanceof Date ? formatDate(date, 'date-time') : '';
});
